import * as _4 from 'lodash4';
import { NumsToDayNamesService } from '../services/nums_to_day_names';
import { IScheduleSectionTime } from '../types/my_schedule_types';
import { ScheduleLocation } from './location_builder';
import { ScheduleSectionTime } from './section_time_builder';

interface ICourseScheduleDisplayData {
  courseType: string;
  days_of_week: number[];
  time: string;
  location: string;
  locationText: string;
  locationLink: {
    desktop: string;
    android: string;
    ios: string;
  };
}

export function DisplayDataBuilderFunction(ngNumsToDayNamesService: NumsToDayNamesService, DayOfTheWeekEnum: any) {
  class DisplayDataBuilderClass {
    private getCourseType(sectionTime: IScheduleSectionTime): string {
      return _4.some(sectionTime as {}, {
        day_of_week: DayOfTheWeekEnum.ONLINE.value.ordinal
      })
        ? DayOfTheWeekEnum.ONLINE.value.shortname
        : 'campus';
    }

    private getLocationText(location: ScheduleLocation) {
      return !_4.isEmpty(location.name) ? location.name : location.address;
    }

    private hasLocation(location: ScheduleLocation) {
      return (
        !(_4.isEmpty(location.longitude) || _4.isEmpty(location.latitude)) &&
        location.longitude !== 0 &&
        location.latitude !== 0
      );
    }

    private buildLocationLink(location: ScheduleLocation) {
      let locationAppend: string = '';
      let iosQueryParam: string = '';
      if (!_4.isEmpty(location.address)) {
        iosQueryParam = `q=`;
        locationAppend = `${location.address}`;
      } else if (this.hasLocation(location)) {
        iosQueryParam = `ll=`;
        locationAppend = `${location.latitude},${location.longitude}`;
      }
      return {
        desktop: _4.isEmpty(locationAppend) ? '' : `https://maps.google.com/?q=${locationAppend}`,
        android: _4.isEmpty(locationAppend) ? '' : `https://maps.google.com/?q=${locationAppend}`,
        ios: _4.isEmpty(locationAppend) ? '' : `maps://maps.apple.com/?${iosQueryParam}${locationAppend}`
      };
    }

    buildDisplayData(data: any): ICourseScheduleDisplayData[] {
      const isOnline = (sectionTime: ScheduleSectionTime) => sectionTime.day_of_week > 7;

      return _4.map(
        _4.groupBy(
          _4.each(data, (sectionTime: any) => {
            if (!isOnline(sectionTime) && !_4.isEmpty(sectionTime.from_tm) && !_4.isEmpty(sectionTime.to_tm)) {
              sectionTime._time = `${moment(sectionTime.from_tm, 'HH:mm:ss').format('h:mm A')} - ${moment(
                sectionTime.to_tm,
                'HH:mm:ss'
              ).format('h:mm A')}`;
            } else {
              sectionTime._time = '';
            }
          }),
          (sectionTime: any) => {
            return sectionTime._time + sectionTime.location;
          }
        ),
        (sectionTimeGroup: ScheduleSectionTime[]) => {
          const defaultLocation = {
            id: -1,
            campus: 0,
            campus_name: undefined,
            name: undefined,
            address: undefined,
            comments: undefined,
            latitude: undefined,
            longitude: undefined
          };

          let location = _4.first(sectionTimeGroup)._location as any;
          if (_4.isEmpty(location)) {
            location = defaultLocation;
          }
          return {
            courseType: this.getCourseType(sectionTimeGroup as any),
            days_of_week: ngNumsToDayNamesService.numsToDayNames(
              _4.sortBy(
                _4.map(sectionTimeGroup, (sectionTime: ScheduleSectionTime) => {
                  return sectionTime.day_of_week;
                })
              ),
              'shortname'
            ),
            time: _4.get(_4.first(sectionTimeGroup as any), '_time', ''),
            location: location.address,
            locationText: this.getLocationText(location),
            locationLink: this.buildLocationLink(location)
          } as ICourseScheduleDisplayData;
        }
      );
    }
  }

  return new DisplayDataBuilderClass();
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/builders/display_data_builder.ts